import type { TOC } from '@ember/component/template-only'
import type { PhosphorIconName } from 'phosphor-icons'

/**
 * The icon component provides a simple way to render an icon with a specific phosphor-icon.
 *
 * @example
 * <PhosphorIcon
 *   @icon="phosphor-acorn-fill"
 *  class="h-6 w-6 text-blue-500"
 * />
 */

interface Signature {
  Element: HTMLSpanElement
  Args: {
    icon: PhosphorIconName
  }
}

export const PhosphorIcon: TOC<Signature> = <template><span class={{@icon}} ...attributes /></template>

export default PhosphorIcon
